import { sum } from 'lib/array/arrayUtils'

export function calculateInsuranceViewPrice(selectedPolicyIds: Set<string>, quote: App.InsuranceQuote) {
  if (!selectedPolicyIds.size) return quote.total
  const quotesOfSelectedPolicies = quote.policyQuotes.filter(policyQuote => selectedPolicyIds.has(policyQuote.policy))
  return sum(quotesOfSelectedPolicies, policy => policy.price)
}
